import React from 'react';
import PropTypes from 'prop-types';
import Dashboard from './Dashboard';

const Page = ({ match }) => <Dashboard id={match.params.id} />;

Page.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Page;
